import {useEffect} from "react";

// Scroll gestures rather than `scroll` events, so programmatic scrolling does not count.
// The pages scroll inside their own containers, so the gestures are caught on the document.
const SCROLL_GESTURES = ['touchmove', 'wheel'];

/**
 * Calls onScroll when the user scrolls the page by touch or mouse wheel outside `ignoreRef`.
 *
 * @param {boolean} active  Listens only while true.
 * @param {{current: (Element|null)}} ignoreRef  Gestures inside this element do not count.
 * @param {function(): void} onScroll
 */
export const usePageScroll = (active, ignoreRef, onScroll) => {
    useEffect(() => {
        if (!active) {
            return undefined;
        }
        const handleGesture = (event) => {
            if (!ignoreRef.current?.contains(event.target)) {
                onScroll();
            }
        };
        SCROLL_GESTURES.forEach((type) => document.addEventListener(type, handleGesture, {passive: true}));
        return () => SCROLL_GESTURES.forEach((type) => document.removeEventListener(type, handleGesture));
    }, [active, ignoreRef, onScroll]);
};
